/*global env,angular*/
'use strict';

var modules = [
  'angulartics',
  'angulartics.google.analytics',
  'angulartics.facebook.pixel',
  'ui.router',
  'ngCookies',
  'angularLocalStorage',
  'ngResource',
  'ngSanitize',
  'ct.ui.router.extras.previous',
  'angularLazyImg',
  'angularSelectbox',
  'MrDWebApp.services',
  'MrDWebApp.seo',
  'duScroll',
  'slugifier',
  'ui.swiper',
  'ui.mask'
];

if (env.cloudErrorReporting) modules.unshift('ngRaven');

angular.module('MrDWebApp', modules)
  .value('duScrollDuration', 2000)
  .config(function ($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider, $analyticsProvider) {

    $analyticsProvider.settings.ga.enhancedEcommerce = true;
    $analyticsProvider.virtualPageviews(false);

    //delete $httpProvider.defaults.headers.common['X-Requested-With'];
    $urlRouterProvider.otherwise('/page-not-found');
    $urlMatcherFactoryProvider.strictMode(false);
    $stateProvider
      .state('error', {
        url: '/page-not-found',
        templateUrl: 'files/_404/404.html',
        controller: 'ErrorCtrl'
      }).state('admin-error', {
        url: '/admin-error',
        templateUrl: 'files/_admin_error/admin_error.html',
        controller: 'AdminErrorCtrl'
      }).state('home', {
        url: '/',
        template: env.domainSplit? '' : undefined,
        templateUrl: env.domainSplit? undefined : 'files/_home/home.html',
        controller: 'HomeCtrl',
        controllerAs: '_hc',
        onEnter: function(){
          if (env.domainSplit) {
            if (env.rootHost) {
              window.location.href = env.rootHost;
            } else {
              window.location.href = '/';
            }
          }
        }
      }).state('map', {
        url: '/map',
        templateUrl: 'files/_map/map.html',
        controller: 'MapCtrl',
        controllerAs: '_mapc'
      }).state('location', {
        url: '/order/restaurants/:lat/:lng/:street_name?label&street_number&suburb&city&province&postal_code&select',
        templateUrl: 'files/_location/location.html',
        controller: 'LocationCtrl',
        controllerAs: '_lc',
        resolve: {
          restaurants: ['$stateParams', 'landingItemsFactory', '$rootScope', function ($stateParams, landingItemsFactory, $rootScope) {
            // console.log('app.js, calling landing items factory');
            return landingItemsFactory.lookup({
              latitude: $stateParams.lat,
              longitude: $stateParams.lng,
              street_name: $stateParams.street_name
            }, function () {
          /* Analytics */ $rootScope.trackRestaurantsLoadSuccess();
              $rootScope.$broadcast('loading:hide');
            }, function () {
          /* Analytics */ $rootScope.trackRestaurantsLoadFailure();
              $rootScope.$broadcast('loading:hide');
              // $rootScope.$broadcast('global_message:show', {
              //   'name': 'restaurants_load_failure',
              //   'for_state': 'location',
              //   'error': {
              //     'friendly_message': 'There was a problem loading restaurants.'
              //   },
              //   'confirm': {
              //     'label': 'Try Again',
              //     'action': 'redirect',
              //     'value': 'location',
              //     'value_object': {
              //       latitude: $stateParams.lat,
              //       longitude: $stateParams.lng
              //     }
              //   },
              //   'deny': {
              //     'label': 'Contact Support',
              //     'action': 'redirect',
              //     'value': 'menu',
              //     'value_object': null
              //   }
              // });
            });

          }]
        }
      }).state('menu', {
        url: '/order/restaurant/:restaurantID/menu/:menuID?preview&lat&lon&st',
        templateUrl: 'files/_menu/menu.html',
        controller: 'MenuCtrl',
        controllerAs: '_mc',
        // params: { restaurant: null },
        resolve: {
          menu: ['$stateParams', 'menuFactory', '$rootScope', function ($stateParams, menuFactory,  $rootScope) {
            // console.log('app.js: resolving menu: '+$stateParams.menuID);
            return menuFactory.get({
              menuID: $stateParams.menuID
            }, function () {
              $rootScope.$broadcast('loading:hide');
            }, function () {
              $rootScope.$broadcast('loading:hide');
            });
          }],

          item: function () {
            console.log('app.js: resolving nothing:');
            return false;
          }
        }
      }).state('cart', {
        url: '/order/cart',
        templateUrl: 'files/_cart/cart.html',
        controller: 'CartCtrl',
        controllerAs: '_cart'
      }).state('confirm-address', {
        url: '/order/confirm-address',
        templateUrl: 'files/_confirm_address/confirm_address.html',
        controller: 'ConfirmAddressCtrl',
        controllerAs: '_confirm_address'
      }).state('checkout', {
        url: '/order/checkout/:userID/:orderID',
        templateUrl: 'files/_checkout/checkout.html',
        controller: 'CheckoutCtrl',
        controllerAs: '_checkout',
        resolve: {
          order: ['$stateParams', 'orderFactory', function ($stateParams, orderFactory) {
            return orderFactory.get({
              userID: $stateParams.userID,
              orderID: $stateParams.orderID
            });
          }]
        }
      }).state('payment_confirm', {
        url: '/order/payment/confirm/:orderID/:userID/:statusID',
        templateUrl: 'files/_payment/payment_confirm.html',
        controller: 'PaymentConfirmCtrl',
        controllerAs: '_pcc',
        resolve: {
          order: ['$stateParams', 'orderFactory', function ($stateParams, orderFactory) {
            return orderFactory.get({
              userID: $stateParams.userID,
              orderID: $stateParams.orderID
            });
          }],
          status: ['$stateParams', function ($stateParams) {
            return $stateParams.statusID;
          }]

        }
      }).state('payment_return', {
        url: '/order/payment/:orderID/:userID/:statusID',
        templateUrl: 'files/_payment/payment_return.html',
        controller: 'PaymentReturnCtrl',
        controllerAs: '_prc',
        resolve: {
          order: ['$stateParams', 'orderFactory', function ($stateParams, orderFactory) {
            return orderFactory.get({
              userID: $stateParams.userID,
              orderID: $stateParams.orderID
            });
          }],
          status: ['$stateParams', function ($stateParams) {
            return $stateParams.statusID;
          }]

        }
      }).state('exceptions', {
        url: '/order/exceptions/:orderID/:userID/:statusID',
        templateUrl: 'files/_exceptions/exceptions.html',
        controller: 'ExceptionsCtrl',
        controllerAs: '_exc',
        resolve: {
          order: ['$stateParams', 'orderFactory', function ($stateParams, orderFactory) {
            return orderFactory.get({
              userID: $stateParams.userID,
              orderID: $stateParams.orderID
            });
          }],
          status: ['$stateParams', function ($stateParams) {
            return $stateParams.statusID;
          }]

        }
      }).state('login', {
        url: '/login',
        templateUrl: 'files/_auth/login.html',
        controller: 'AuthCtrl',
        controllerAs: '_auth',
        onEnter: function() {
          window.ga('send', 'event', 'log_in_page', 'view_log_in_screen');
        }
      }).state('register', {
        url: '/register',
        templateUrl: 'files/_auth/register.html',
        controller: 'AuthCtrl',
        controllerAs: '_auth',
        onEnter: function() {
          window.ga('send', 'event', 'sign_up_page', 'view_sign_up_screen');
          window._adjustEvent('pl6sve'); //registration_started
        }
      }).state('forgot', {
        url: '/forgot',
        templateUrl: 'files/_auth/forgot.html',
        controller: 'AuthCtrl',
        controllerAs: '_auth'
      }).state('reset', {
        url: '/reset-password/:token',
        templateUrl: 'files/_auth/reset-password.html',
        controller: 'AuthCtrl',
        controllerAs: '_auth'
      }).state('old_login', { // Old Login (Backup for NGINX)
        url: '/order/login',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            $state.go('login');
          }]
      }).state('old_register', { // Old Register (Backup for NGINX)
        url: '/order/register',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            $state.go('register');
          }]
      }).state('old_forgot', { // Old Forgot (Backup for NGINX)
        url: '/order/forgot',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            $state.go('forgot');
          }]
      }).state('account', {
        url: '/order/account/:deprecatedUserId',
        templateUrl: 'files/_profile/account.html',
        controller: 'ProfileCtrl',
        controllerAs: '_profile',
        resolve: {
          profile: ['$stateParams', 'userFactory', 'storage', function ($stateParams, userFactory, storage) {
            var access = storage.get('mrd-web-access');
            return userFactory.get({
              userID: access? access.user.id : null
            });
          }]
        }
      }).state('profile', {
        url: '/order/profile/:deprecatedUserId?view',
        templateUrl: 'files/_profile/profile.html',
        controller: 'ProfileCtrl',
        controllerAs: '_profile',
        resolve: {
          profile: ['$stateParams', 'userFactory', 'storage', function ($stateParams, userFactory, storage) {
            var access = storage.get('mrd-web-access');
            return userFactory.get({
              userID: access? access.user.id : null
            });
          }]
        }
      }).state('profile-data-request', {
        url: '/order/profile-data-request',
        templateUrl: 'files/_profile/data-request.html',
        controller: 'ProfileCtrl',
        controllerAs: '_profile',
        resolve: {
          profile: ['$stateParams', 'userFactory', 'storage', function ($stateParams, userFactory, storage) {
            var access = storage.get('mrd-web-access');
            return userFactory.get({
              userID: access? access.user.id : null
            });
          }]
        }
      }).state('profile-data-delete', {
        url: '/order/profile-data-delete',
        templateUrl: 'files/_profile/data-delete.html',
        controller: 'ProfileCtrl',
        controllerAs: '_profile',
        resolve: {
          profile: ['$stateParams', 'userFactory', 'storage', function ($stateParams, userFactory, storage) {
            var access = storage.get('mrd-web-access');
            return userFactory.get({
              userID: access? access.user.id : null
            });
          }]
        }
      })
      .state('wallet', {
        url: '/order/wallet',
        templateUrl: 'files/_wallet/wallet.html',
        controller: 'WalletCtrl',
        controllerAs: '_wallet',
        resolve: {
          profile: ['$stateParams', 'userFactory', 'storage', function ($stateParams, userFactory, storage) {
            var access = storage.get('mrd-web-access');
            return userFactory.get({
              userID: access? access.user.id : null
            });
          }],
          walletHistory: ['walletFactory', 'storage', function(walletFactory, storage) {
              var access = storage.get('mrd-web-access');
              return walletFactory.history({
                userID: access? access.user.id : null
             });
          }]
        }
      })
      .state('tracking', {
        url: '/order/tracking/:orderID/:deprecatedUserId?map&chat',
        templateUrl: 'files/_tracking_details/tracking.html',
        controller: 'OrderTrackingCtrl',
        controllerAs: '_tracking_details',
        reloadOnSearch: false, // do not relaod controller on query param change
        resolve: {
          order: ['$stateParams', 'orderFactory', 'storage', function ($stateParams, orderFactory, storage) {
            var access = storage.get('mrd-web-access');
            return orderFactory.get({
              userID: access? access.user.id : null,
              orderID: $stateParams.orderID
            });
          }]
        }
      }).state('collection', {
        url: '/order/collection/:orderID/:deprecatedUserId',
        templateUrl: 'files/_tracking_details/collection.html',
        controller: 'OrderDetailsCtrl',
        controllerAs: '_tracking_details',
        resolve: {
          order: ['$stateParams', 'orderFactory', 'storage', function ($stateParams, orderFactory, storage) {
            var access = storage.get('mrd-web-access');
            return orderFactory.get({
              userID: access? access.user.id : null,
              orderID: $stateParams.orderID
            });
          }]
        }
      }).state('details', {
        url: '/order/details/:orderID/:deprecatedUserId?view',
        templateUrl: 'files/_tracking_details/details.html',
        controller: 'OrderDetailsCtrl',
        controllerAs: '_tracking_details',
        resolve: {
          order: ['$stateParams', 'orderFactory', 'storage', function ($stateParams, orderFactory, storage) {
            var access = storage.get('mrd-web-access');
            return orderFactory.get({
              userID: access? access.user.id : null,
              orderID: $stateParams.orderID
            });
          }]
        }
      }).state('history', {
        url: '/order/history/:deprecatedUserId',
        templateUrl: 'files/_history/history.html',
        controller: 'HistoryCtrl',
        controllerAs: '_history',
        resolve: {
          orders: ['$stateParams', 'orderFactory', 'storage', function ($stateParams, orderFactory, storage) {
            var access = storage.get('mrd-web-access');
            return orderFactory.history({
              userID: access? access.user.id : null
            });
          }]
        }
      }).state('faq', {
        url: '/help/faq',
        templateUrl: 'files/_pages/faq.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('terms', {
        url: '/terms',
        templateUrl: 'files/_pages/terms.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('pp', {
        url: '/privacy-policy',
        templateUrl: 'files/_pages/pp.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('contactus-redirect', {
        url: '/contactus',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            $state.go('contact');
          }]
      }).state('contact', {
        url: '/contact',
        templateUrl: 'files/_pages/contact.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('bulk', {
        url: '/bulk-ordering',
        templateUrl: 'files/_pages/bulk.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('old-drivers', { // Old Drivers
        url: '/become-a-driver-partner',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            $state.go('become-a-driver');
          }]
      }).state('easy-drivers', { // Old Drivers
        url: '/signup',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            $state.go('become-a-driver');
          }]
      }).state('become-a-driver', {
        url: '/become-a-driver',
        templateUrl: 'files/_pages/driver-signup.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('become-a-restaurant-partner', {
        url: '/become-a-restaurant-partner',
        templateUrl: 'files/_pages/restaurant-signup.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('careers', {
        url: '/careers',
        templateUrl: 'files/_pages/careers.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('press', {
        url: '/press',
        templateUrl: 'files/_pages/press.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('offline', {
        url: '/order/offline',
        templateUrl: 'files/_maintenance/offline.html',
        controller: 'MaintenanceCtrl',
        controllerAs: '_maintenance'
      }).state('mrdelivery', {
        url: '/mrdelivery',
        controller: ['$scope', '$state',
        function ($scope, $state) {
          $state.go('mr-delivery-is-now-mr-d-food');
        }]
      }).state('mr-delivery-is-now-mr-d-food', {
        url: '/mr-delivery-is-now-mr-d-food',
        templateUrl: 'files/_pages/mrdelivery.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('mrd_luxe', {
        url: '/mr-d_luxe_premium_restaurant_selection',
        templateUrl: 'files/_seo/mrd_luxe.html',
        controller: 'SEOCtrl',
        controllerAs: '_seo'
      })
      .state('seo_groups', {
        url: '/food-delivery/restaurants/:group',
        templateUrl: 'files/_seo/group.html',
        controller: 'SEOCtrl',
        controllerAs: '_seo',
        resolve: {
          doesntReallyMatter: function($stateParams, $rootScope, $filter, $location){
            if(typeof $rootScope.seo_manifest[$stateParams.group] === 'undefined'){
              $location.path('/');
            }
          }
        }
      }).state('seo_first', {
        url: '/food-delivery/:first',
        templateUrl: 'files/_seo/default.html',
        controller: 'SEOCtrl',
        controllerAs: '_seo',
        resolve: {
          doesntReallyMatter: function($stateParams, $rootScope, $location){
            if(typeof $rootScope.seo_manifest[$stateParams.first] === 'undefined'){
              $location.path('/page-not-found');
            } else {
              // Rediract groups out early... they have other url structure
              // if($rootScope.seo_manifest[$stateParams.first] == 'group'){
              //   console.log('here2');
              //   //$location.path('/food-delivery/restaurants/' + $stateParams.first);
              // } else {
              //   console.log('no')
              $rootScope.tempStateParams = $stateParams; // Save so that i can use it in the resourceInterceptor to load alternative view...
                //console.log($stateParams)
              return $stateParams;
              // }

            }
          }
        }
      }).state('seo_second', {
        url: '/food-delivery/:first/:second',
        templateUrl: 'files/_seo/default.html',
        controller: 'SEOCtrl',
        controllerAs: '_seo',
        resolve: {
          doesntReallyMatter: function($stateParams, $rootScope, $location){
            if(typeof $rootScope.seo_manifest[$stateParams.first] === 'undefined' || typeof $rootScope.seo_manifest[$stateParams.second] === 'undefined'){
              $location.path('/');
            }
             // Rediract groups out early... they have other url structure
            if($rootScope.seo_manifest[$stateParams.second] === 'group'){
              $location.path('/food-delivery/restaurants/' + $stateParams.second); // Eek
            }
            $rootScope.tempStateParams = $stateParams; // Save so that i can use it in the resourceInterceptor to load alternative view...
            return $stateParams;
          }
        }
      }).state('sitemap', {
        url: '/sitemap',
        templateUrl: 'files/_pages/sitemap.html',
        controller: 'PagesCtrl',
        controllerAs: '_pages'
      }).state('order', { // Old Order Page
        url: '/order',
        controller: ['$scope', '$state',
          function ($scope, $state) {
            if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
          }]
      });

    $locationProvider.html5Mode(true);
  })
  .run(function ($rootScope, $cookies, $window, storage, $http, $location, $timeout, $state, $previousState, $analytics) {

    $rootScope.state = $state;
    $rootScope.application_version = 'v1.166.0';
    $rootScope.build = '16';
    $rootScope.commit = 'f94da7fcf438d7488e3716839d0057237a5e0279';
    $rootScope.branchtag = 'tag/v1.179.3-rc0';
    if (~$rootScope.branchtag.indexOf('release-')) { //branch
      $rootScope.application_version = $rootScope.branchtag.substr(8);
    } else if (~$rootScope.branchtag.indexOf('hotfix-')) { //branch
      $rootScope.application_version = $rootScope.branchtag.substr(7);
    } else if (~$rootScope.branchtag.indexOf('-rc')) { //tag
      $rootScope.application_version = $rootScope.branchtag.substring(0, $rootScope.branchtag.indexOf('-rc'));
    } else if ($rootScope.branchtag.charAt(0) !== '[') { //tag
      $rootScope.application_version = $rootScope.branchtag;
    }
    window.Raven.setRelease($rootScope.commit);

    if ($rootScope.build === '['+'BUILD-TOKEN'+']') {
      $rootScope.build = '99999';
    }
    if ($rootScope.branchtag === '['+'TAG'+']') {
      $rootScope.branchtag = '';
    }
    if ($rootScope.commit === '['+'SH1'+']') {
      $rootScope.commit = '';
    }

    if (env.name !== 'PROD') {
      document.getElementById('dev').style.display = 'table';
      var elm = document.getElementById('dev-content');
      elm.innerHTML = '<strong>' + env.name + '</strong><br/>' + $rootScope.application_version;
      elm.onclick = function(){
        if (window.confirm('Build: ' + $rootScope.build + '\nBranch/Tag: ' + $rootScope.branchtag + '\nCommit: ' + $rootScope.commit + '\n\nCopy commit SH1 to clipboard?')) {
          var el = document.createElement('textarea');
          el.value = $rootScope.commit;
          el.setAttribute('readonly', '');
          el.style.position = 'absolute';
          el.style.left = '-9999px';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
        }
      };
    }
    window.ver = 'Branch/Tag: '+$rootScope.branchtag+', Commit: '+$rootScope.commit;
    if ($rootScope.commit) console.log('Version', window.ver);

    // Hackin
    $rootScope.saveRestaurantsTemp = {};

    var access = storage.get('mrd-web-access');
    if (access) {
      $http.defaults.headers.common.Authorization = access.auth;
      if (access.user && access.user.id) {
        // $http.defaults.headers.common['x-user-id'] = access.user.id;
      }
    }

    // Global Loading and Added to Statechange.
    //$rootScope.$broadcast('cart:modified'); // Example
    $rootScope.$on('overlay:show', function (event, args) {
      angular.element(document).find('html').addClass('overlay-active');
      if (args.callback) { args.callback(); } // Return back to where you came from... if you so wished...
    });
    $rootScope.$on('overlay:hide', function () {
      angular.element(document).find('html').removeClass('overlay-active');
    });
    $rootScope.$on('loading:show', function () {
      angular.element(document).find('html').addClass('loading-active');
    });
    $rootScope.$on('loading:hide', function () {
      angular.element(document).find('html').removeClass('loading-active');
    });

    // Global Popup Message, Confirm and Deny's
    $rootScope.$on('global_message:show', function (event, responseData) {
      var main_message;
      console.log(responseData);
      if (responseData.error) {
        main_message = responseData.error.friendly_message;
      } else {
        main_message = '';
      }
      $rootScope.global_message = {
        main_message: main_message,
        name: null,
        for_state: null,
        confirm_title: false,
        confirm_message: false,
        confirm_label: false,
        confirm_value: false,
        confirm_value_object: false,
        confirm_action: false,
        deny_title: false,
        deny_message: false,
        deny_label: false,
        deny_value: false,
        deny_value_object: false,
        deny_action: false,
        customActions: null
      };
      if (responseData.name) {
        $rootScope.global_message.name = responseData.name;
      }
      if (responseData.title) {
        $rootScope.global_message.title = responseData.title;
      }
      if (responseData.for_state) {
        $rootScope.global_message.for_state = responseData.for_state;
      }
      if (responseData.confirm) {
        $rootScope.global_message.confirm_title = responseData.confirm.title;
        $rootScope.global_message.confirm_message = responseData.confirm.message;
        $rootScope.global_message.confirm_label = responseData.confirm.label;
        $rootScope.global_message.confirm_value = responseData.confirm.value;
        $rootScope.global_message.confirm_value_object = responseData.confirm.value_object;
        $rootScope.global_message.confirm_action = responseData.confirm.action;
      }
      if (responseData.deny) {
        $rootScope.global_message.deny_title = responseData.deny.title;
        $rootScope.global_message.deny_message = responseData.deny.message;
        $rootScope.global_message.deny_label = responseData.deny.label;
        $rootScope.global_message.deny_value = responseData.deny.value;
        $rootScope.global_message.deny_value_object = responseData.deny.value_object;
        $rootScope.global_message.deny_action = responseData.deny.action;
      }
      if (responseData.customActions) {
        for (var i = 0; i<responseData.customActions.length; i++) {
          var act = responseData.customActions[i];
          switch (act.style) {
            case 'primary':
              act.styleClass = 'confirm';
              act.styleClassInner = 'button arrow-right-dark';
              break;
            case 'secondary':
              act.styleClass = 'deny';
              act.styleClassInner = 'button button-cancel arrow-left-dark';
              break;
          }
        }
        $rootScope.global_message.customActions = responseData.customActions;
      }
      // If the current state name is not meant for global message being displayed. (Order promises)
      //console.log($rootScope.state.current.name,$rootScope.global_message.for_state);
      //console.log('here')

      //console.log($rootScope.state.current.name,$rootScope.global_message.for_state);

      if ($rootScope.global_message.for_state === $rootScope.state.current.name ||
        $rootScope.global_message.for_state === 'any') {
        angular.element(document).find('html').addClass('global-message-active');
      }
      if (!responseData.confirm && !responseData.deny && !responseData.customActions) {

        $timeout(function () {
          $rootScope.$broadcast('global_message:hide');
        }, 3000);
      }

    });
    $rootScope.$on('global_message:hide', function () {
      angular.element(document).find('html').removeClass('global-message-active');
    });
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {/*toParams, fromState, fromParams, options*/

      // Might be outstanding promises that need to be cancelled

      $rootScope.$broadcast('seo_update', { state: toState });

      $rootScope.$broadcast('loading:hide');
      if (toState.name !== 'home' &&
        toState.name !== 'error' &&
        toState.name !== 'admin-error' &&
        toState.name !== 'app' &&
        toState.name !== 'map' &&
        toState.name !== 'order' &&
        toState.name !== 'location' &&
        toState.name !== 'menu' &&
        toState.name !== 'item' &&
        toState.name !== 'cart' &&
        toState.name !== 'register' &&
        toState.name !== 'forgot' &&
        toState.name !== 'reset' &&
        toState.name !== 'appterms' &&
        toState.name !== 'offline' &&
        toState.name !== 'confirm-address' &&
        toState.name !== 'contactus-redirect' &&
        toState.name !== 'old-drivers' &&
        toState.name !== 'easy-drivers' &&
        toState.name !== 'mrdelivery' &&
        toState.controllerAs !== '_pages' &&
        toState.controllerAs !== '_restaurants' &&
        toState.controllerAs !== '_restaurants_area' &&
        toState.controllerAs !== '_restaurant_group' &&
        toState.controllerAs !== '_restaurant' &&
        toState.controllerAs !== '_area' &&
        toState.controllerAs !== '_group' &&
        toState.controllerAs !== '_cuisine_tag' &&
        toState.controllerAs !== '_seo' &&
        toState.name !== 'login' &&
        !angular.element(document).find('html').scope()._rc.access.loggedin
      ) {
        // User isn’t authenticated
        $rootScope.postLoginState = toState.name;
        $state.transitionTo('login');
        event.preventDefault();
      }

      if (toState.name === 'location' || toState.name === 'menu' || toState.name === 'item') {
        $rootScope.$broadcast('loading:show'); // Example
      }

      var hash = $location.hash();
      if (hash) {
           toParams['#'] = hash;
      }
    });
    $rootScope.$on('$stateChangeSuccess', function () { // (event, toState)

      $window.scroll(0, 0);
      $timeout(function () {
        $analytics.pageTrack($location.url(), { title: angular.element(document).find('html').scope()._rc.title_tag }); // :puke:
      }, 500);
    });

    $rootScope.global_message_size = function(message){
      if(message){
        if(message.length > 100){
          return 'message-large-copy';
        }
      }
    };


    $rootScope.show404Popup = function(){
      $rootScope.$broadcast('loading:hide');
      $rootScope.$broadcast('global_message:show',{
        'name': 'api_error',
        'for_state': 'any',
        'title': 'CRAB!',
        'error' : {
          'friendly_message': 'Sadly the page or item you were looking for is extinct.'
        },
        'confirm' : {
          'label': 'Return Home',
          'action': 'redirect',
          'value': 'home'
        },
        'deny' : false
      });
    };

    $rootScope.show403Popup = function(){
      $rootScope.$broadcast('loading:hide');
      $rootScope.$broadcast('global_message:show', {
        'name': 'api_error',
        'for_state': 'any',
        'title': 'Access Forbidden',
        'error' : {
          'friendly_message': 'You don\'t not have sufficient access to this page.'
        },
        'confirm' : {
          'label': 'Return Home',
          'action': 'redirect',
          'value': 'home'
        },
        'deny' : false
      });
    };

    $rootScope.show500Popup = function(){
      $rootScope.$broadcast('loading:hide');
      $rootScope.$broadcast('global_message:show', {
        'name': 'api_error',
        'for_state': 'any',
        'title': 'Something is not right...',
        'error' : {
          'friendly_message': 'There has been a unusual error in your request. If the problem presists please contact support.'
        },
        'confirm' : {
          'label': 'Return Home',
          'action': 'redirect',
          'value': 'home'
        },
        'deny' : false
      });
    };

  }).config(function ($httpProvider) {
    $httpProvider.interceptors.push('resourceInterceptor');
  }).factory('injectCSS', function ($q) {
    var injectCSS = {};

    var createLink = function (id, url) {
      var link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      return link;
    };

    var checkLoaded = function (url, deferred, tries) {
      for (var i in document.styleSheets) {
        var href = document.styleSheets[i].href || '';
        if (href.split('/').slice(-1).join() === url) {
          deferred.resolve();
          return;
        }
      }
      tries++;
      setTimeout(function () { checkLoaded(url, deferred, tries); }, 50);
    };

    injectCSS.set = function (id, url) {
      var tries = 0,
        deferred = $q.defer(),
        link;

      if (!angular.element(document).find('#' + id).length) {
        link = createLink(id, url);
        link.onload = deferred.resolve;
        angular.element(document).find('head').append(link);
      }
      checkLoaded(url, deferred, tries);

      return deferred.promise;
    };

    return injectCSS;

  }).factory('resourceInterceptor', function ($location, $rootScope, $q, storage) {
    return {
      request: function (config) {

        if (
          config.url === 'https://takealot.zendesk.com/api/v2/tickets.json' ||
          config.url === 'https://api.greenhouse.io/v1/boards/takealotcom/jobs' ||
          config.url === 'http://mrd.us8.list-manage.com/subscribe/post-json?u=c043277d2d0ad5e8841f7c8b9&id=4960d20747&c=jsonpcallback'
        ) {
          console.log('Resource interceptor bypass for 3rd party enpoints.');
          return config;
        }

        var seo_term = false;
        // Hackery!
        if(config.url === 'files/_seo/default.html') {
          if($rootScope.tempStateParams && $rootScope.tempStateParams.second){
            seo_term = $rootScope.seo_manifest[$rootScope.tempStateParams.second];
            if(seo_term === 'suburb' && config.url !== 'files/_seo/city.html'){
              config.url = 'files/_seo/city.html';
            }
            if(seo_term === 'group' && config.url !== 'files/_seo/group.html'){
              config.url = 'files/_seo/group.html';
            }
          } else if ($rootScope.tempStateParams && $rootScope.tempStateParams.first) {
            seo_term = $rootScope.seo_manifest[$rootScope.tempStateParams.first];
            if(seo_term === 'cuisine_type' && config.url !== 'files/_seo/cuisine-type.html'){
              config.url = 'files/_seo/cuisine-type.html';
            }
            if(seo_term === 'city' && config.url !== 'files/_seo/city.html'){
              config.url = 'files/_seo/city.html';
            }
            if(seo_term === 'group' && config.url !== 'files/_seo/group.html' && $rootScope.tempStateParams.second){
              config.url = 'files/_seo/group.html';
            }
            if(seo_term === 'group' && config.url === 'files/_seo/default.html' && $rootScope.tempStateParams.first){
              config.url = 'files/_seo/group.html'; // Just to change it...
              $location.path('/food-delivery/restaurants/' + $rootScope.tempStateParams.first);
            }
          }
          if(config.url === 'files/_seo/default.html') { // If it's still this...
            //$location.path('/page-not-found');
            $location.path('/'); // Redirect Home..
          }

        }


        config.headers['X-Api-Key'] = '8991c720-203f-4e18-af78-d4b32aa49005';
        config.headers['X-Client-Id'] = 'WEB_APP';
        config.headers['X-Client-Version'] = $rootScope.application_version;
        config.headers['X-Client-Build-Number'] = $rootScope.build? $rootScope.build : '999999';
        if ($rootScope.commit) {
          config.headers['X-Client-Src-Link'] = $rootScope.commit;
        }

        if (navigator) {
          config.headers['X-Platform-Version'] = navigator.userAgent;
        } else {
          config.headers['X-Platform-Version'] = 'unknown';
        }

        if (config.url.split('/').pop() === 'landing-items') {
          var access = storage.get('mrd-web-access');
          if (access) config.headers['x-user-id'] = access.user.id;
        }

        return config;
      },
      // response: function (config) {
      //   console.log('response',config)
      //   return config;
      // },
      responseError: function (config) {
        if (config.config && config.config.bypassErrorHandler) return $q.reject(config);

        if (parseInt(config.status) === 553) { // API DOWN
          $rootScope.offline_response = config.data.error;
          $location.url('/order/offline');
          return config;
        }
        if (parseInt(config.status) === 500) {
          $rootScope.show500Popup();
        }
        if (parseInt(config.status) === 404) {
          $rootScope.show404Popup();
        }
        if (parseInt(config.status) === 403) {
          $rootScope.show403Popup();
        }
        // if (parseInt(config.status) === -1) { // Hack for CORS
        //   return config;
        // }
        return $q.reject(config);
      }
    };
  }).filter('capitalize', function () {
    return function (input) {
      var output = '';
      if(!!input) {
        var modifiedInput = input.split(' ');
        if(modifiedInput.length > 1){
          modifiedInput.forEach(function(element) {
            output += element.charAt(0).toUpperCase() + element.substr(1).toLowerCase() + ' ';
          });
        } else {
          output += input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
        }
      }
      return output;
    };
  }).directive('staticInclude', function ($http, $templateCache, $compile) {
    return function (scope, element, attrs) {
      var templatePath = attrs.staticInclude;
      $http.get(templatePath, { cache: $templateCache }).success(function (response) {
        var contents = element.html(response).contents();
        $compile(contents)(scope);
      });
    };
  }).directive('eatClickIf', ['$parse', '$rootScope',
    function ($parse, $rootScope) {
      return {
        // this ensure eatClickIf be compiled before ngClick
        priority: 100,
        restrict: 'A',
        compile: function ($element, attr) {
          var fn = $parse(attr.eatClickIf);
          return {
            pre: function link(scope, element) {
              var eventName = 'click';
              element.on(eventName, function (event) {
                var callback = function () {
                  if (fn(scope, { $event: event })) {
                    // prevents ng-click to be executed
                    event.stopImmediatePropagation();
                    // prevents href
                    event.preventDefault();
                    return false;
                  }
                };
                if ($rootScope.$$phase) {
                  scope.$evalAsync(callback);
                } else {
                  scope.$apply(callback);
                }
              });
            },
            post: function () { }
          };
        }
      };
    }
  ]).directive('forceLowerCase', function ($parse) {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {

        var lowerize = function (inputValue) {
          if (!inputValue) { return inputValue; }
          var lowerized = inputValue.toLowerCase();
          if (lowerized !== inputValue) {
            modelCtrl.$setViewValue(lowerized);
            modelCtrl.$render();
          }
          return lowerized;
        };

        var model = $parse(attrs.ngModel);
        modelCtrl.$parsers.push(lowerize);
        lowerize(model(scope));
      }
    };
  }).directive('orderTicker', function ($interval, $timeout, $window) {

    var animate = true, w = $window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (ua.indexOf('chrome') > -1) {
        // Chrome Do Nothing
      } else { // Safari
        if (w >= 980) {
          animate = false; // Stupid safari creates unfixable flickering on fonts with CSS animations
        }
      }
    }

    function link(scope, element) { // ,attrs
      var timerId, tOriginal = 507373, t = tOriginal - 500;// 27 April 2017

      function flipTo(digit, n) {
        var current = angular.element(digit[0]).attr('data-num');
        angular.element(digit[0]).attr('data-num', n);
        angular.element(digit[0].querySelector('.front')).attr('data-content', current).css('display', 'block');
        angular.element(digit[0].querySelector('.back')).attr('data-content', n).css('display', 'block');
        angular.element(digit[0].querySelector('.under')).attr('data-content', n).css('display', 'block');
        $timeout(function () {
          angular.element(digit[0].querySelector('.base')).text(n);
          angular.element(digit[0].querySelector('.front')).css('display', 'none');
          angular.element(digit[0].querySelector('.back')).css('display', 'none');
          angular.element(digit[0].querySelector('.under')).css('display', 'none');
        }, 350);
      }

      function jumpTo(digit, n) {
        angular.element(digit[0]).attr('data-num', n);
        angular.element(digit[0].querySelector('.base')).text(n);
      }

      function updateGroup(group, n, flip) {
        var digit = angular.element(element[0].querySelector('.' + group));
        //console.log('.'+group,digit);
        if (angular.element(digit[0]).attr('data-num') !== n) {
          if (flip) { flipTo(digit, n); }
          else { jumpTo(digit, n); }
        }
      }

      function setTime(flip) {
        t = t + Math.round(Math.random() * 5);
        var newT = t + '';
        if (newT.length > 5) {
          updateGroup('b1000000', newT.substr(newT.length - 6).substring(0, 1), flip);
        } else {
          updateGroup('b1000000', '0', flip);
        }
        updateGroup('b100000', newT.substr(newT.length - 5).substring(0, 1), flip);
        updateGroup('b10000', newT.substr(newT.length - 4).substring(0, 1), flip);
        updateGroup('b1000', newT.substr(newT.length - 3).substring(0, 1), flip);
        updateGroup('b100', newT.substr(newT.length - 2).substring(0, 1), flip);
        updateGroup('b10', newT.substr(newT.length - 1), flip);
        if (t === tOriginal) {
          $interval.cancel(timerId);
        }
      }

      setTime(false);

      if (animate) {
        timerId = $interval(function () {
          setTime(true);
        }, 2500);
      }
      element.on('$destroy', function () {
        $interval.cancel(timerId);
      });

    }
    return {
      transclude: true,
      templateUrl: 'files/templates/order-ticker.html',
      link: link
    };
  });
